<template>
  <PieChart
    :request-status="requestStatus"
    :series="series"
    :title="title"
    :item-id="itemId"
    is-polarity
    class="make-a-copy"
    v-bind="$attrs"
    @reload="getData"
  />
</template>

<script>
import PieChart from '@/components/cards/models/PieChart';
import sentimentModel from '@/mixins/sentiment-model';
import { mapActions } from 'vuex';
import EventBus from '@/utils/event-bus';

export default {
  name: 'BaseSentimentPieChart',
  components: {
    PieChart,
  },
  mixins: [
    sentimentModel,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      requestStatus: 'loading',
      rawSeries: [],
      axesSeriesName: [],
    };
  },
  computed: {
    series() {
      if (this.rawSeries && this.axesSeriesName) {
        return this.axesSeriesName.map(serieName => {
          const serie = this.rawSeries.find(serie => serie.name === serieName);
          return {
            color: this.getSentimentColor(serie.name),
            name: this.getSentimentLabel(serie.name),
            y: serie.data[0] || 0,
          };
        });
      }
      return [];
    },
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getWarroomService',
    ]),
    getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }

      const request = this.getWarroomService({
        itemId: this.itemId,
        servicePath: 'monitoringOverview',
      });

      request
        .then(response => {
          const normalizedResponse = this.normalizeMonitoringOverviewSentiment(response);
          this.rawSeries = normalizedResponse.points;
          this.axesSeriesName = normalizedResponse?.axes[1]?.values;

          if (!this.axesSeriesName) {
            this.axesSeriesName = ['Negativo', 'Neutro', 'Positivo'];
          }

          this.rawSeries = this.newSentimentArray(this.rawSeries);

          if (options?.silentRefresh) {
            EventBus.$emit('updated', { itemId: this.itemId });
          }
        })
        .catch(error => {
          console.error(error);
          this.requestStatus = 'error';
        });
    },
    normalizeMonitoringOverviewSentiment(response) {
      const sentiment = response.general_sentiment || {};
      const series = [
        { name: 'negative_value', value: sentiment.negative_value },
        { name: 'neutral_value', value: sentiment.neutral_value },
        { name: 'positive_value', value: sentiment.positive_value },
      ];

      return {
        axes: [null, { values: series.map(({ name }) => name) }],
        points: series.map(({ name, value }) => ({
          name,
          data: [value || 0],
        })),
      };
    },
    newSentimentArray(arr) {
      const validateArray = arr.length === 1 && arr[0].data.length === 1 && arr[0].name === undefined;

      this.requestStatus = 'success';

      if (validateArray) {
        const newArray = [
          { 'name': 'Neutro', 'data': [0] },
          { 'name': 'Positivo', 'data': [0] },
          { 'name': 'Negativo', 'data': [0] },
        ];

        return newArray;
      }
      return arr;
    },
  },
};
</script>
